import React from 'react';
import { Section } from '../ui/Section';
import { Button } from '../ui/Button';
import { motion } from 'framer-motion';
export function FinalCTASection() {
  return <Section background="white" className="pt-0 pb-32" id="comprar" data-id="element-23">
      <div className="bg-[#3D2314] rounded-3xl overflow-hidden shadow-2xl relative" data-id="element-24">
        <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/cubes.png')] opacity-5" data-id="element-25"></div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 p-12 md:p-20 items-center relative z-10" data-id="element-26">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} data-id="element-27">
            <h2 className="text-3xl md:text-5xl font-serif font-bold text-[#FAF8F5] mb-6 leading-tight" data-id="element-28">
              Empieza hoy a aprender de las mentes que cambiaron la humanidad.
            </h2>
            <p className="text-[#E0D8D0] text-lg mb-10 max-w-md" data-id="element-29">
              Accede inmediatamente a todo el contenido y comienza tu viaje de
              transformación intelectual.
            </p>
            <a href="https://go.hotmart.com/J104173419C?dp=1" target="_blank" rel="noopener noreferrer" className="inline-block w-full md:w-auto" data-id="element-30">
              <Button size="lg" withIcon className="w-full md:w-auto" data-id="element-31">
                DESCARGAR EL PACK AHORA
              </Button>
            </a>
            <p className="mt-4 text-sm text-[#E0D8D0]/60" data-id="element-32">
              Acceso inmediato • Pago seguro • Garantía de satisfacción
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.9,
          rotate: 5
        }} whileInView={{
          opacity: 1,
          scale: 1,
          rotate: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} className="relative" data-id="element-33">
            <div className="absolute -inset-10 bg-[#C9A227]/20 blur-3xl rounded-full -z-10" data-id="element-34"></div>
            <img src="https://cdn.magicpatterns.com/uploads/mfTprJZ5mZK3UCpFYMivxz/MOCKUP_GENIOS_VOL.2.png" alt="Pack Completo Vol. 2" className="w-full h-auto drop-shadow-2xl" data-id="element-35" />
          </motion.div>
        </div>
      </div>
    </Section>;
}